import { QuickLinkItem } from '../../welcome/home/home-types';
import { UserPersistedState } from './userpersistedstate-types';

export const defaultQuickLinks: QuickLinkItem[] = [
  {
    to: '/templates/new/selectview',
    title: 'Build New Template',
    icon: 'file pdf'
  },
  {
    to: '/profile',
    title: 'My Profile Settings',
    icon: 'cog'
  },
  {
    to: '/users/create',
    title: 'Add New User',
    icon: 'user plus'
  },
  {
    to: '/users/groups/create',
    title: 'Create New Group',
    icon: 'users'
  }
];

// these defaults only get used/set if the user has no persisted state
const defaults: UserPersistedState = {
  showRecentTemplates: true,
  defaultFormsListDateFilter: 90,
  firstTemplateStarted: true,
  firstTemplatePublished: true,
  hideHipaaSetupBanner: false,
  hideFindFormResponseTooltip: false,
  quickLinks: defaultQuickLinks,
  dismissGetStartedOnboarding: false,
  dismissDunningBanner: false,
  dismissDeleteNotificationPrompt: false,
  editorTypeHighlightDismissed: null,
  jobsListColumnOrder: ['status', 'name', 'failedStep', 'attempts', 'startDate'],
  recentFormSearchesFormsPage: [],
  recentFormSearchesTemplatesPage: [],
  whitelabelButtonAura: true
};

export default defaults;
